module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-container"
  }, [(_vm.total > _vm.pageSize) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "result-table",
      "data": _vm.tableData,
      "border": "",
      "element-loading-text": "Loading...."
    },
    on: {
      "sort-change": _vm.handleSort
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "personaname",
      "label": "PLAYER",
      "sortable": "custom",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "wrapper peer-icon-wrapper",
          staticStyle: {
            "display": "flex",
            "align-items": "center"
          }
        }, [_c('img', {
          directives: [{
            name: "lazy",
            rawName: "v-lazy",
            value: (scope.row.avatar),
            expression: "scope.row.avatar"
          }],
          staticStyle: {
            "height": "29px",
            "box-shadow": "0 0 5px rgba(0, 0, 0, .4)",
            "margin-left": "0 auto"
          },
          attrs: {
            "alt": ""
          }
        }), _vm._v(" "), _c('a', {
          staticClass: "peer-name-wrapper",
          staticStyle: {
            "margin-left": "10px",
            "color": "#6BF",
            "text-decoration": "none"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.viewUser(scope.row.account_id)
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.personaname))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "games",
      "label": "MP",
      "sortable": "custom",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "with_games",
      "label": "With",
      "width": "150",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "With Win Rate",
      "prop": "with_win_rate",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.with_win_rate) + "%")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "against_games",
      "label": "Against",
      "width": "150",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "against_win_rate",
      "label": "Against Win Rate",
      "sortable": "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.against_win_rate) + "%")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total > _vm.pageSize) ? _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-617fe3c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Peers.vue
// module id = 141
// module chunks = 1